import type { ApiModuleEndpoints } from '../types'
export const voucherApiEndpoints = {
  list: { method: 'GET', path: '/vouchers' },
  detail: { method: 'GET', path: '/vouchers/:id' },
  create: { method: 'POST', path: '/vouchers' },
  update: { method: 'PUT', path: '/vouchers/:id' },
  activate: { method: 'POST', path: '/vouchers/:id/activate' },
  pause: { method: 'POST', path: '/vouchers/:id/pause' },
  archive: { method: 'POST', path: '/vouchers/:id/archive' },
} as const satisfies ApiModuleEndpoints
